<template>
  <div class="container-fluid bg-info text-white">
    <div class="row title-card">
      <div class="col-10 text-left"><span v-show="spinner"><icon name="cog" scale="2.5" spin></icon></span> <h4>Ranking</h4></div>
      <div class="col-2 text-right"><b-link class="text-white" :to="{ name: 'home' }"><icon name="times" scale="2"></icon></b-link></div>
    </div>
    <div class="row mt-2 no-gutters" v-for="(store, index) in ranking.stores" v-bind:key="'s'+index" v-bind:id="'store-'+index">
      <template v-if="store.access == true">
        <div class="col-7 col-sm-6 col-md-4 col-lg-2 col-xl-2 offset-md-2 offset-lg-3 offset-xl-3 pt-2"><b-link class="text-white" :to="{ name: 'score', params: { store: store.id_store }}">{{ store.ranking }}º {{ store.nm_store }}</b-link></div>
        <div class="col-4 col-sm-5 col-md-3 col-lg-3 col-xl-3 offset-xl-0"><b-link class="text-white" :to="{ name: 'score', params: { store: store.id_store }}"><b-progress show-value height="34px" variant="warning" :precision="1" :value="store.sc_store"></b-progress></b-link></div>
        <div class="col-1 col-sm-1 col-md-1 col-lg-1 pl-2"><b-link class="text-white" :to="{ name: 'score', params: { store: store.id_store }}"><icon name="caret-right" scale="1.8"></icon></b-link></div>
      </template>
      <template v-else>
        <div class="col-7 col-sm-6 col-md-4 col-lg-2 col-xl-2 offset-md-2 offset-lg-3 offset-xl-3 pt-2">{{ store.ranking }}º {{ store.nm_store }}</div>
        <div class="col-4 col-sm-5 col-md-3 col-lg-3 col-xl-3 offset-xl-0"><b-progress show-value height="34px" variant="warning" :precision="1" :value="store.sc_store"></b-progress></div>
        <div class="col-1 col-sm-1 col-md-1 col-lg-1"></div>
      </template>
    </div>
  </div>
</template>

<script>
import { http } from '../http'
import swal from 'sweetalert2'
import Icon from 'vue-awesome'

export default {
  components: { Icon },
  data () {
    return {
      stores: JSON.parse(localStorage.getItem('stores')),
      spinner: true,
      ranking: []
    }
  },
  beforeCreate: function() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted () {
    if (localStorage.getItem('level') == 'supervisor') {
      http.get('/ranking/geral').then(response => { this.spinner = false; this.ranking = response.data; })
    }

    if (localStorage.getItem('level') == 'store') {
      http.get('/ranking/geral/'.this.$route.params.store).then(response => { this.spinner = false; this.ranking = response.data; })
    }
  }
}
</script>


<style scoped>
.container-fluid { min-height:100vh; }
.container-fluid .title-card { padding:20px 0; }
.container-fluid .title-card span { display:block; width:40px; height:40px; float:left; border-radius:20px; font-size:20px; color:#17A2B8; background:#FFF; line-height:40px; text-align:center; margin-right:24px; }
.container-fluid .title-card h4 { font-size:1.5em; color:#FFF; line-height:40px; }
</style>



// WEBPACK FOOTER //
// src/components/Ranking.vue